import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import SidebarPanel from './SidebarPanel';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: true, 
            Notifications: false,
            Logged: false,
            CUSTOMER_DET: ''
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmLogin')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmLogin')[0].classList.add('was-validated');

        if(err==0)
        {
			var pass = $('#txtpassword').val();
			$('#txtpassword').val(window.b64_md5(pass));
			
            $('#submitLoading').css('display','block');
            
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://m.donedelivery.in/api/customer_api.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {

                let notify = '';
                if(result.err!='')
                {
                    if(result.err=='1') notify = 'Mobile No Field is Empty';
                    else if(result.err=='2') notify = 'Password Field is Empty';
                    else if(result.err=='3') notify = 'Mobile No Not Found';
                    else if(result.err=='4') notify = 'Invalid Access Detected';
                    else if(result.err=='5') notify = 'No Such User Exist';
                    else if(result.err=='6') notify = 'Invalid Password Entered';
                    else if(result.err=='7') notify = 'Mobile Area Code Field is Empty';
                }

                let logged = false;

                let customer = result.customer;
                if(customer!='' && customer!=undefined)
                {
                    localStorage.setItem('userData',customer);
                    localStorage.setItem('Verified',result.verified);
                    logged = true;
                }

                that.setState({ Notifications: notify, Logged:logged });
                $('#submitLoading').css('display','none');
                if(notify!='')
                    $('#ModalAlert').modal('show');
          });
        }
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api2.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CUSTOMER_DET:CUSTOMER_DET  });
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    componentDidMount() {
        var customer = localStorage.getItem('userData');
        this.fetchCustomerProfile('PROFILE',customer);
        //this.setState({ LOADING:false });
    }

    render() {

        if(localStorage.getItem('userData')) {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
			    return (<Redirect to={'/home'}/>)
		}

        if (this.state.Logged) {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
			    return (<Redirect to={'/home'}/>)
		}

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);
        if(cart !== null && cart!=='{}')
        {
            cartEMPTY = 'N';
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = (cartEMPTY=='N')?'/cart':'/home';
        let AppHeaderTitle = 'Sign in';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';
    
        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="login-form mt-1">
                        <div className="section pt-6">
                            <img src="/assets/img/done-image.png" alt="image" className="form-image imaged w140" />
                        </div>
                        <div className="section mt-5 mb-5 pr-3 pl-3">
                            <form name="frmLogin" id="frmLogin" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                                <input type="hidden" defaultValue="SIGNIN" className="form-control" name="mode" id="mode" required />
                                <input type="hidden" className="form-control" defaultValue={localStorage.getItem('SUBSCRIBER_ID')} name="webpushr_id" id="webpushr_id" />
                                <div className="form-group boxed mb-1">
                                    <div className="wid-20">
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="txtusercode">Code</label>
                                            <input type="text" className="square-inputbox form-control" name="txtusercode" id="txtusercode" required minLength="3" maxLength="6" defaultValue='+91' autoComplete="off"/>
                                            <i className="clear-input">
                                                <ion-icon name="close-circle"></ion-icon>
                                            </i>
                                            <div className="valid-feedback">&nbsp;</div>
                                            <div className="invalid-feedback">Please enter your area code.</div>
                                        </div>
                                    </div>
                                    <div className="wid-80"> 
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="txtusermobile">Mobile No</label>
                                            <input type="text" className="square-inputbox form-control" name="txtusermobile" id="txtusermobile" required minLength="10" maxLength="10" pattern="[0-9]{10}" autoComplete="off"/>
                                            <i className="clear-input">
                                                <ion-icon name="close-circle"></ion-icon>
                                            </i>
                                            <div className="valid-feedback">&nbsp;</div>
                                            <div className="invalid-feedback">Please enter your 10 digit mobile no.</div>
                                        </div>
                                    </div>
                                    <div className="clear"></div>
                                </div>                                
                                <div className="form-group boxed">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtpassword">Password</label>
                                        <input type="password" className="square-inputbox form-control" name="txtpassword" id="txtpassword" required autoComplete="off"/>
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                        <div className="valid-feedback">&nbsp;</div> 
                                        <div className="invalid-feedback">Please enter your password.</div>  
                                    </div>
                                </div>
                                <div className="form-links">
                                    <div>
                                        <Link to="/register" className="font-weg-400 text-danger">Register</Link>
                                    </div>
                                    <div>
                                        <Link to="/forgot-password" className="text-lgrey font-weg-400">Forgot Password?</Link>
                                    </div>
                                </div>
                                <div className="form-button-group pl-4 pr-4 bg-common">
                                    <button type="submit" className="lt-space1 text-upper btn btn-danger btn-block square btn-md">
                                        <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                        Sign in</button>
                                </div>
                            </form>
                        </div>
                        <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-icon text-danger">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </div>
                                    <div className="modal-body"> 
                                            {this.state.Notifications} 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js